<template>
  <el-card class="h-full" :body-style="{ height: '100%', overflow: 'auto' }">
    <div class="flex items-center">
      <span class="border-l-3 border-color-primary flex-1 pl-10px text-18px">导航栏设置</span>
    </div>
    <div class="mt-20px">
      <el-form :model="form" ref="form" label-width="150px" :disabled="!canEdit">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item
              label="栏目个数"
              :rules="[{ required: true, message: '请选择栏目个数', trigger: 'change' }]"
            >
              <el-select v-model="columnNum" class="w-full">
                <el-option v-for="item in 9" :key="item" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="8" v-for="(item, index) in form.columnIds" :key="`id${index}`">
            <el-form-item
              :label="`栏目${index + 1}`"
              :rules="[{ required: true, message: '请选择栏目', trigger: 'change' }]"
              :prop="`columnIds[${index}]`"
            >
              <el-select v-model="form.columnIds[index]" class="w-full" clearable>
                <el-option
                  v-for="column in getColumnFilterData(form.columnIds[index])"
                  :key="column.id"
                  :label="column.name"
                  :value="column.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="w-full fixed bottom-20px left-1/2">
      <el-button
        v-if="!canEdit"
        size="small"
        type="primary"
        @click="canEdit = true"
      >
        编辑
      </el-button>
      <el-button v-if="canEdit" size="small" type="primary" @click="submit">
        保存
      </el-button>
      <el-button v-if="canEdit" size="small" @click="cancel">
        取消
      </el-button>
    </div>
  </el-card>
</template>

<script>
import { ColumApi, WorkbenchSettingApi } from '@wiz-api/workbench'

const columnApi = new ColumApi()
const workbenchSettingApi = new WorkbenchSettingApi()
export default {
  data() {
    return {
      canEdit: false,
      columnNum: 1,
      form: {
        columnIds: [],
      },
      columnData: [],
    }
  },
  computed: {
    columnFilterData() {
      return _.filter(this.columnData, (item) => {
        return !this.form.columnIds.includes(item.id)
      })
    },
  },
  watch: {
    columnNum: {
      immediate: true,
      handler() {
        this.form.columnIds.length = this.columnNum
      },
    },
  },
  async created() {
    await this.getColumnData()
    await this.getSetting()
  },
  methods: {
    async getSetting() {
      const [err, res] = await workbenchSettingApi.getWorkbenchSetting({ code: 'navConfig' })
      if (!err && res.config) {
        this.form = JSON.parse(res.config)
        this.columnNum = this.form.columnIds.length || 1
      }
    },
    async getColumnData() {
      const [err, res] = await columnApi.tree(0)
      if (!err) {
        this.columnData = res
      }
    },
    getColumnFilterData(columnId) {
      const column = _.find(this.columnData, { id: columnId })
      if (column) {
        return _.concat([column], this.columnFilterData)
      }
      return this.columnFilterData
    },
    submit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const [err, res] = await workbenchSettingApi.updateWorkbenchSetting({
            body: {
              config: JSON.stringify(this.form),
              code: 'navConfig',
            },
          })
          if (!err) {
            this.$message.success('修改成功')
            this.getSetting()
            this.canEdit = false
          }
        }
      })
    },
    cancel() {
      this.$refs.form.clearValidate()
      this.canEdit = false
      this.getSetting()
    },
  },
}
</script>

<style lang="scss" scoped></style>
